import React from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { CustomCardFooter } from "@components/Common/CustomCardStyled";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

interface Props {
    isConsult: boolean;
    onCancel: () => void;
    onValidate: () => void;
}

const InformationFormFooter = React.memo(
    ({ isConsult, onCancel, onValidate }: Props) => {
        const { t } = useTranslation();

        return (
            <CustomCardFooter className="pt-1 pb-2">
                <CustomSecondaryColorButton
                    outline
                    rounded
                    variant="light"
                    className="mr-2 mdi_btn_FRcancel cmn_btn_cancel"
                    onClick={onCancel}
                >
                    <span>{t("Cancel")}</span>
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    variant="primary"
                    className={`mdi_btn_FRvalidate cmn_btn_validate ${classnames(
                        {
                            "not-allowed-input-vr__clz": isConsult,
                        }
                    )}`}
                    onClick={onValidate}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </CustomCardFooter>
        );
    }
);

InformationFormFooter.displayName = "InformationFormFooter";
export default InformationFormFooter;
